import { alpha, ThemeOptions } from '@mui/material';

export const MuiSkeleton: ThemeOptions['components']['MuiSkeleton'] = {
  defaultProps: {
    animation: 'wave'
  },
  styleOverrides: {
    root: ({ theme }) => {
      return {
        '&.MuiSkeleton-rectangular': {
          borderRadius: theme.spacing(0.5)
        },
        background: theme.palette.action.hover,
        '&::after': {
          background: `linear-gradient(90deg,
          ${alpha(theme.palette.text.primary, 0)} 0%,
          ${alpha(theme.palette.text.primary, 0.06)} 50%,
          ${alpha(theme.palette.text.primary, 0)} 96.88%)`,
          animationDuration: '1.8s',
          animationTimingFunction: 'ease-out'
        }
      };
    }
  }
};
